import React, { useState } from 'react';
import { Loading } from '../../../redux/action';
import { connect } from 'react-redux';
import { Tabs, Tab } from "react-bootstrap";
import Positive from '../../../assets/images/positive.png';
import Negative from '../../../assets/images/negative.png';
import Neutral from '../../../assets/images/neutral.png';
import { DefaultUserProfile } from '../../../config/config';

interface Props {
  UserReducer: any;
  loading: (data: any) => void;
  paidComments?: any;
  organicComments?: any;
  totalCommentsCount: any;
  title?: string;
  comments?: any;
}

const CommentsTab: React.FC<Props> = ({ title, comments = [] }) => {
  const [tabKey, setTabKey] = useState("positive");

  const safeComments = Array.isArray(comments) ? comments : [];

  const positive = safeComments.filter((c: any) => c.score > 0);
  const neutral = safeComments.filter((c: any) => c.score === 0);
  const negative = safeComments.filter((c: any) => c.score < 0);

  const total = positive.length + neutral.length + negative.length;

  const getPercentage = (count: number) =>
    total > 0 ? ((count / total) * 100).toFixed(0) : "0";

  const renderCommentList = (list: any[]) => (
    <ul className="comment-tab-content-list">
      {list.map((item, index) => (
        <li className="comment-tab-content-item" key={index}>
          <img
            className="comment-tab-content-item-img"
            src={DefaultUserProfile.influencer_unknown_default}
            alt=""
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
          <div className="comment-tab-content-item-detail">
            <span className="comment-tab-content-item-user">
              {item.user_commenting}
            </span>
            <span className="comment-tab-content-item-user-comment">
              {item.comments}
            </span>
          </div>
        </li>
      ))}
    </ul>
  );

  if (total === 0) return null;

  return (
    <div className="brand-insight-highchart comment-analysis-tab-sec">
      <div className="brand-insight-highchart-top">
        <strong className="brand-insight-highchart-title">
          {title}
        </strong>
      </div>

      <div className="brand-insight-highchart-data">
        <Tabs
          activeKey={tabKey}
          onSelect={(k) => setTabKey(k || "positive")}
          className="comment-analysis-tab"
        >
          <Tab
            eventKey="positive"
             className='comment-tab-content'
            title={
              <>
                <img className="me-1" src={Positive} alt="" />
                Positive <strong>{getPercentage(positive.length)}%</strong>
              </>
            }
          >
            {renderCommentList(positive)}
          </Tab>

          <Tab
            eventKey="negative"
             className='comment-tab-content'
            title={
              <>
                <img className="me-1" src={Negative} alt="" />
                Negative <strong>{getPercentage(negative.length)}%</strong>
              </>
            }
          >
            {renderCommentList(negative)}
          </Tab>

          <Tab
            eventKey="neutral"
             className='comment-tab-content'
            title={
              <>
                <img className="me-1" src={Neutral} alt="" />
                Neutral <strong>{getPercentage(neutral.length)}%</strong>
              </>
            }
          >
            {renderCommentList(neutral)}
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};
const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
  };
};

const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(CommentsTab);

export { connectToRedux as CommentsTab };